export default __webpack_public_path__ + "static/media/showroom39.d7f3e1e5.jpg";